export enum documentsUrls {
    generalDeclaration = "documents/general-declaration",
    manifests = "documents/manifests",
    manifestEntry = "documents/manifests/entry"
}